import React from "react";
export const defaultIconClassName = "before:bg-black-100 before:transition-colors dark:before:bg-white";
export const Icon = ({ identifier, className = defaultIconClassName, additionalClassName = "" }) => {
    return React.createElement("span", { className: `icon ${identifier} ${className} ${additionalClassName}`, "aria-hidden": true });
};
